var App = App || {};

App.StayInTouchBand = (function ($) {
    "use strict";

    var sitBands = $(".component.component-sit-band");

    function init() {
        sitBands.each(function () {
            var formGroup = $(this).find(".form-group"),
                input = $(this).find(".kentico-form input.form-control"),
                button = $(this).find(".kentico-form input.btn");

            button.remove().insertAfter(input);

            button.hover(
                function () {
                    formGroup.addClass("hovered-submit");
                },
                function () {
                    formGroup.removeClass("hovered-submit");
                }
            );

            button.focusin(function () {
                formGroup.addClass("focused-submit");
            });

            button.focusout(function () {
                formGroup.removeClass("focused-submit");
            });
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.StayInTouchBand.init();
});